import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function deleteUser(id: number | undefined): Promise<void> {
    if (api.userApi) {
        await api.userApi.usersDelete(id).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            } else {
                store.doNotice(lang.deleteUser, true);
            }
        });
    }
}

export { deleteUser };
